import Constants from "../services/Constants";

export const buildCommonFilters = (filters) => {
  let parameters = {};
  Object.keys(filters).forEach(key => {
    if ((filters[key] !== undefined) && (filters[key].length > 0 || Boolean(filters[key]))) {
      parameters[key] = filters[key];
    }
  });
  return parameters;
}

export const buildStatusCountersParams = ({filters}) => {
  const otherFilters = (({interventionStatus, ...other}) => other)(filters);
  const interventionStatus = filters.interventionStatus.length > Constants.STATUS_FILTER.length ? []
    : filters.interventionStatus.filter(f => !Constants.FILTER_COUNTERS.interventionStatusCount.includes(f));
  const statusCount = Constants.FILTER_COUNTERS.interventionStatusCount.filter(f => filters.interventionStatus.includes(f))
  return {
    interventionStatus: interventionStatus,
    interventionStatusCount: filters.interventionStatus.length === 0 ? Constants.FILTER_COUNTERS.interventionStatusCount : statusCount,
    combineCounts: true,
    ...buildCommonFilters(otherFilters)
  }
}

export const buildTypeCountersParams = ({filters}) => {
  const otherFilters = (({type, ...other}) => other)(filters);

  return {
    typeCount: Constants.TYPE_PITSTOP.value,
    type: filters.type.filter(f => f !== Constants.TYPE_PITSTOP.value),
    combineCounts: false,
    ...buildCommonFilters(otherFilters)
  }
}



// WEBPACK FOOTER //
// ./src/helpers/filters.js